<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-row>
        <b-col>
          <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
            <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
          </b-button>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-button v-b-modal.modal-factura @click="loadTipo" variant="warning">
            {{ $t('adjuntar_documento') }}
          </b-button>
        </b-col>
      </b-row>


      <b-card-header class="border-0">
        <h3 class="mb-0">{{ $t('documentos') }} #{{ this.$route.params.id }}</h3>
        <b-col>
          <b-form-group>
            <b-modal id="modal-factura" size="xl" scrollable :title="$t('adjuntar_documento')" @ok="adjuntarDocumento"
              no-close-on-backdrop :ok-title="$t('adjuntar')">
              <b-row>
                <b-col cols="5">
                  <b-form-group label-for="file-input"><template v-slot:label>
                      {{ $t('documento') }}<span class="text-danger">*</span>
                    </template>
                    <b-form-file id="file-input" required v-model="adjunto.file" :browse-text="$t('adjuntar')"
                      :state="adjunto.file ? true : null" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .bmp"
                      :placeholder="$t('selecciona_archivo')">
                    </b-form-file>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label-for="numero-input">
                    <template v-slot:label>
                      {{ $t('tipo') }} <span class="text-danger">*</span>
                    </template>
                    <b-form-select id="tipo-adjunto" v-model="adjunto.tipoID">
                      <option :value="null">{{ $t('seleccione_opcion') }}</option>
                      <option v-for="option in tipoAdjuntoOptions" :key="option.value" :value="option.value">
                        {{ option.text }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-modal>
          </b-form-group>
        </b-col>

        <b-col>
          <h3 class="d-flex justify-content-center w-100 mb-0">
            <b-badge class="badge-lg" variant="info">
              <strong>*Se necesitan documentos de tipo: Ingreso, Salida, Guía de Traslado y Ticket Inexlink para poder
                generar el
                acta.</strong>
            </b-badge>
          </h3>
        </b-col>
      </b-card-header>

      <b-card-header class="border-0">
        <Loading v-if="loading" />
        <b-row v-else>
          <b-col md="2">
            <b-form-group :label="$t('ingreso')">
              <template v-if="adjuntos && adjuntos.filter(x => x.tipoID == 1).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 1)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" variant="danger"
                    class="ml-4 mt-2 mb-3">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('salida')">
              <template v-if="adjuntos && adjuntos.filter(x => x.tipoID == 2).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 2)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('guia_traslado')">
              <template v-if="adjuntos && adjuntos.filter(x => x.tipoID == 3).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 3)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('ticket_inex')">
              <template v-if="adjuntos && adjuntos.filter(x => x.tipoID == 5).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 5)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('ticket')">
              <template v-if="adjuntos && adjuntos.filter(x => x.tipoID == 4).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 4)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('descuento')">
              <template v-if="adjuntos.filter(x => x.tipoID == 6).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 6)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('no_conformidad')">
              <template v-if="adjuntos.filter(x => x.tipoID == 7).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 7)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('acta_procedencia')">
              <template v-if="adjuntos.filter(x => x.tipoID == 8).length > 0">
                <div v-for="item in adjuntos.filter(x => x.tipoID == 8)" :key="item.id">
                  <FileViewer :id="item.id" :url="item.url" />
                  <b-button v-if="rol == 'admin'" @click="deleteAdjunto(item.id)" class="ml-4 mt-2 mb-3"
                    variant="danger">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <a href="#" class="text-danger">{{ $t('no_documentos_cargados') }}</a>
                </div>
              </template>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-header>
    </base-header>
  </div>
</template>
<script>
import ingresoService from '@/api/ingresoService';
import FileViewer from '@/components/FileViewer';
import utilsService from '@/api/utilsService';
import miscService from '@/api/miscService';
import Loading from '@/components/Loading.vue';
export default {
  components: {
    FileViewer,
    Loading
  },
  data() {
    return {
      adjuntos: [],
      adjunto: {
        file: null,
        tipoID: null,
        ingresoID: 0
      },
      tipoAdjuntoOptions: [],
      loading: true
    };
  },
  computed: {
    rol() {
      return utilsService.getRol();
    },
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.adjuntos = await ingresoService.getAdjuntos(id);
    this.adjunto.ingresoID = id;
    this.loading = false;
  },
  methods: {
    async adjuntarDocumento(event) {
      event.preventDefault();
      if (!this.adjunto || this.adjunto.file == null || this.adjunto.tipoID == null) {
        this.$toast.error('Por favor, completa los campos requeridos..', {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });
        return;
      }

      Swal.fire({
        title: this.$t('estas_seguro'),
        text: this.$t('confirma_adjunto'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {

          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });

            const response = await ingresoService.addAdjunto(this.adjunto);
            if (!response) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: this.$t('error'),
              });
              return;
            }

            this.adjuntos = await ingresoService.getAdjuntos(this.adjunto.ingresoID);
            this.$bvModal.hide('modal-factura');

            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$t('error'),
            });
            return;
          }
        }
      });
    },
    async loadTipo() {
      this.tipoAdjuntoOptions = await miscService.getTipoAdjuntoOptions();
    },
    async deleteAdjunto(id) {
      Swal.fire({
        title: this.$t('estas_seguro'),
        text: this.$t('confirma_eliminar_doc'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('si_eliminar'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {

          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">` + this.$t('eliminando') + `</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });

            const response = await ingresoService.delAdjunto(id);
            if (!response) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: this.$t('error')
              });
              return;
            }

            const ingresoID = this.$route.params.id;
            this.adjuntos = await ingresoService.getAdjuntos(ingresoID);

            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$t('error')
            });
            return;
          }
        }
      });
    },

  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
